export class SearchQueryApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns any
     * @throws ApiError
     */
    getIndex() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/search-query',
        });
    }
    /**
     * @returns SearchQuery
     * @throws ApiError
     */
    createSearchQuery({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/search-query',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SearchQuery
     * @throws ApiError
     */
    get({ id, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/search-query/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns SearchQueryCandidate
     * @throws ApiError
     */
    samplePeopleForQuery({ id, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/search-query/{id}/sample',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    feedback({ id, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/search-query/{id}/feedback',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
